const ITEMS = [
  "Palm Jumeirah",
  "Burj Khalifa",
  "Emirates Hills",
  "Jumeirah Bay Island",
  "Dubai Hills",
  "District One",
  "Bulgari Resort",
  "Atlantis The Royal",
  "Tilal Al Ghaf",
  "Six Senses",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#1c1c1c]/10 bg-[#f5f0e8] overflow-hidden py-6"
    >
      <div className="marquee-track flex gap-12 whitespace-nowrap">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display text-xl lg:text-2xl text-[#1c1c1c]/85 hover:text-[#c5a059] transition-colors"
          >
            {t} <span className="text-[#c5a059] mx-4">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
